module.exports = __webpack_public_path__ + "front-static/media/flagSprite42.a261d6f8a0f28bb00db733a2baaa2cfc.png";